import React from 'react';
import _ from 'lodash';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { FavRow } from '../components';

const List = styled.div`
  height: auto;
  overflow: scroll;
`;

const FavList = ({ theme, pairs }) => (
  <ThemeProvider theme={theme}>
    <List>{_.map(pairs, pair => <FavRow pair={pair} key={pair.id} />)}</List>
  </ThemeProvider>
);

export default withTheme(FavList);



// WEBPACK FOOTER //
// ./src/components/FavList.js